import type { SerializedEditorState, SerializedParagraphNode, SerializedTextNode } from 'lexical';

const buildParagraph = (text: string): SerializedParagraphNode => {
    const textNode: SerializedTextNode = {
        detail: 0,
        format: 0,
        mode: 'normal',
        style: '',
        text,
        type: 'text',
        version: 1,
    };

    return {
        children: [textNode],
        direction: 'ltr',
        format: '',
        indent: 0,
        textFormat: 0,
        textStyle: '',
        type: 'paragraph',
        version: 1,
    };
};

const emptyRoot = (): SerializedEditorState => ({
    root: {
        children: [],
        direction: 'ltr',
        format: '',
        indent: 0,
        type: 'root',
        version: 1,
    },
});

/**
 * Append a plain-text paragraph to an existing Lexical serialized state.
 * When the existing state is missing or has no content, returns a fresh state
 * containing only the new paragraph.
 */
export const appendPlainTextToLexical = (
    existing: SerializedEditorState | null | undefined,
    text: string,
): SerializedEditorState => {
    const base = existing ?? emptyRoot();

    if (!text) {
        return base;
    }

    return {
        ...base,
        root: {
            ...base.root,
            children: [...base.root.children, buildParagraph(text)],
        },
    };
};
